import React from "react";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ModuleIconBadge from "../../../../ModuleIconBadge";

/**
 * The icon a non-Estimation row carries.
 *
 * With a `moduleKey`, the module's own colour-coded badge (see
 * constants/moduleVisuals.js) - for rows that stand for a module, section,
 * discipline or register, so each one is recognisable at a glance and looks
 * the same here as in the module launcher.
 *
 * Without one, a muted neutral mark - for placeholder rows and individual
 * register entries, which should read as quieter than the folders above them.
 */
export const TreeNodeIcon = ({ moduleKey }) =>
  moduleKey ? (
    <ModuleIconBadge moduleKey={moduleKey} size="xs" />
  ) : (
    <AccountTreeIcon fontSize="inherit" sx={{ color: "text.disabled" }} />
  );

export default TreeNodeIcon;
